<template>
  <div class="DataTable">
    <v-form ref="form12" v-model="valid">
      <div style="display: none">
        <v-flex xs1 pa-2>
          <v-autocomplete
            v-model="id_prostorije"
            :items="room_items"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="Prostorija"
            required
            persistent-hint
            return-object
          ></v-autocomplete>
        </v-flex>
      </div>
    </v-form>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs5 pa-2>
          <v-text-field
            v-model="naziv"
            label="Naziv"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
          ></v-text-field>
        </v-flex>
        
        <v-flex xs4 pa-2>
          <v-autocomplete
            v-model="id_tip_tanka"
            :items="tank_to_items"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            label="Tip tanka"
            required
            persistent-hint
            return-object
            v-on:change="changeRoute"
            :disabled="sarza == 1 && nema_burica === false ? true : false"
          ></v-autocomplete>
        </v-flex>

        <template v-if="id_tip_tanka === 15 && nema_burica === false">
          <v-flex xs1 pa-2>
            <!-- <v-btn class="mx-2" fab dark color="teal" style="font-size: 40px;"
              @click.stop="otvoriModal_izabrani_tankovi">
        +
      </v-btn> -->
            <v-btn
              class="mx-1"
              fab
              dark
              color="teal"
              @click.stop="otvoriModal_izabrani_tankovi"
            >
              <v-icon
                title="Dodavanje/uklanjanje barika"
                style="font-size: 35px; padding-bottom: 10px; top: 0px"
                >+</v-icon
              >
            </v-btn>
          </v-flex>
        </template>
        <template v-if="id_tip_tanka === 15 && nema_burica === true">
          <v-flex xs1 pa-2>
            <!-- <v-btn class="mx-2" fab dark color="teal" style="font-size: 40px;"
              @click.stop="otvoriModal">
        +
      </v-btn> -->
            <v-btn class="mx-1" fab dark color="teal" @click.stop="otvoriModal">
              <v-icon
                title="Dodavanje/uklanjanje barika"
                style="font-size: 35px; padding-bottom: 10px; top: 0px"
                >+</v-icon
              >
            </v-btn>
          </v-flex>
        </template>
      </v-layout>
      <!-- /.Name -->

      <v-layout row wrap>
        <v-flex xs2 pa-2 v-if="sarza !== 1">
          <v-text-field
            v-model="inventoryNumber"
            label="Inventarni broj"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="kapacitet"
            label="Kapacitet"
            type="number"
            :disabled="sarza == 1 ? true : false"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            persistent-hint
            return-object
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-autocomplete
            v-model="jm_select"
            :items="jm_items"
            item-text="mark"
            item-value="id"
            label="JM"
            :rules="[(v) => !!v || 'Obavezan podatak']"
            required
            persistent-hint
            return-object
            :disabled="sarza == 1 || disabled == 0 ? true : false"
          ></v-autocomplete>
        </v-flex>

        <v-flex xs3 pa-2 v-if="vidljiv_broj_barika">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              readonly
              @blur="datum_kupovine = parseDate(dateFormatted)"
              :label="label1"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              clearable
            ></v-text-field>
            <v-date-picker
              v-model="datum_kupovine"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs3 pa-2 v-else>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              readonly
              @blur="datum_kupovine = parseDate(dateFormatted)"
              :label="label1"
              clearable
            ></v-text-field>
            <v-date-picker
              v-model="datum_kupovine"
              no-title
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs3 pa-2>
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted1"
              readonly
              @blur="datum_deaktivacije = parseDate(dateFormatted1)"
              label="Datum deaktivacije"
            clearable
            ></v-text-field>
            <v-date-picker
              v-model="datum_deaktivacije"
              no-title
              @input="menu1 = false"
              :max="maxDate"
              
            ></v-date-picker>
          </v-menu>

        </v-flex>
      </v-layout>
      <template v-if="id_tip_tanka !== 15 && sarza !== 1">
        <v-layout row wrap>
          <v-flex xs3 pa-2>
            <v-text-field
              v-model="tip_materijala"
              label="Materijal"
            ></v-text-field>
          </v-flex>
          <v-flex xs1 pa-2 v-if="enumPom === 'barique' || enumPom === 'barrel'">
            <v-text-field
              v-model="nagorelost"
              label="Nagorelost"
            ></v-text-field>
          </v-flex>
          <v-flex xs5 pa-2>
            <v-text-field
              v-model="proizvodjac"
              label="Proizvodjač"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="cena"
              label="Cena"
              type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-autocomplete
              v-model="jm_valuta"
              :items="currency_items"
              item-text="mark"
              item-value="id"
              label="Valuta"
              persistent-hint
              return-object
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </template>
      <!-- /.Name -->

      <v-layout row wrap>
        <v-flex xs10 pa-2>
          <!-- <v-textarea v-model="opis" name="input-5-1" class="Description" label="Opis"></v-textarea> -->
          <v-text-field
            v-model="opis"
            name="input-5-1"
            label="Opis"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="pozicija"
            type="number"
            label="Redosled na prikazu"
                  v-on:keypress="isNumber"
                  min="1"
          ></v-text-field>
        </v-flex>
        <v-flex
          xs2
          pa-2
          v-if="(id_tip_tanka_barik === 14 && ID === 0) || sarza === 1"
        >
          <v-text-field
            v-model="broj_barika"
            name="input-5-1"
            :label="labelKomada"
            type="number"
            min="1"
            :disabled="sarza == 1 ? true : false"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2 v-if="id_tip_tanka_barik === 15 || sarza === 1">
          <v-text-field
            v-model="prefiks"
            name="input-5-1"
            label="Prefiks"
            maxlength="3"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear_pom" class="AppButtonOutlined">odustani</v-btn>
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <v-dialog
      v-model="dialogNote"
      scrollable
      content-class="ModalInModalSrednji"
    >
      <v-container>
        <div class="DataTable">
          <v-form ref="form_modal" v-model="valid" lazy-validation>
            <v-layout>
              <v-flex xs11 pa-2 style="font-size: 20px !important">
                Dodavanje praznih barika u šaržu - {{ this.naziv }}
              </v-flex>
              <v-flex xs1 pa-2>
                <a
                  class="closeModalInModalBtn"
                  @click.prevent="closeModalInModal"
                >
                  <v-icon>close</v-icon>
                </a>
              </v-flex>
            </v-layout>

            <v-layout column>
              <v-flex style="overflow: auto">
                <v-data-table
                  v-model="selected_prazni_barici"
                  :headers="headers_modal"
                  :items="items_modal"
                  hide-actions
                  class="elevation-1"
                  show-select
                  dense
                  select-all
                  :pagination.sync="pagination"
                >
                  <template slot="headers" slot-scope="props_modal">
                    <tr>
                      <th style="text-align: center; padding: 5px">
                        <v-checkbox
                          primary
                          hide-details
                          @click.native="toggleAll_prazni_barici"
                          :input-value="props_modal.all"
                          :indeterminate="props_modal.indeterminate"
                        ></v-checkbox>
                      </th>
                      <th
                        style="text-align: center; padding: 5px"
                        v-for="header in props_modal.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : '',
                        ]"
                        @click="changeSort(header.value)"
                      >
                        <v-icon>arrow_upward</v-icon>
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props_modal">
                    <tr :active="props_modal.selected">
                      <td style="text-align: center; padding: 5px">
                        <v-checkbox
                          primary
                          hide-details
                          :input-value="props_modal.selected"
                          @click="props_modal.selected = !props_modal.selected"
                        ></v-checkbox>
                        <!-- v-model="props_modal.item.selected" -->
                      </td>
                      <td style="display: none">{{ props_modal.item.id }}</td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.name }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.inventoryNumber }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDate1(props_modal.item.bayingDate) }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{
                          props_modal.item.capacity +
                          " " +
                          props_modal.item.unitOfMeasure.mark.replace(
                      "psc",
                      "kom"
                    )
                        }}
                      </td>

                      <td
                        style="text-align: center; padding: 5px"
                        v-if="props_modal.item.materialType !== null"
                      >
                        {{ props_modal.item.materialType }}
                      </td>
                      <td v-else>{{ "" }}</td>
                      <td
                        style="text-align: center; padding: 5px"
                        v-if="props_modal.item.producer !== null"
                      >
                        {{ props_modal.item.producer }}
                      </td>
                      <td v-else>{{ "" }}</td>
                      <td style="text-align: right">
                        <img
                          class="DataTable__Button"
                          title="Dodavanje barika"
                          src="../assets/icons/zatabele/ico-options.svg"
                          alt="delete-item"
                          @click="otvoriDialog(props_modal.item)"
                        />
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-btn @click.stop="dodajPrazneBarike" class="AppButtonFilled"
                  >Dodaj izabrane barike</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_izabrani_tankovi"
      scrollable
      content-class="ModalInModalGrafic"
    >
      <v-container style="padding: 10px">
        <div class="DataTable">
          <v-form ref="form_modal" v-model="valid" lazy-validation>
            <v-layout>
              <v-flex xs11 pa-2 style="font-size: 20px !important">
                Spisak barika u šarži - {{ this.naziv }}
              </v-flex>
              <v-flex xs1 pa-2>
                <a
                  class="closeModalInModalBtn"
                  @click.prevent="closeModalInModal_izabrani_tankovi"
                >
                  <v-icon>close</v-icon>
                </a>
              </v-flex>
            </v-layout>

            <v-layout column>
              <v-flex style="overflow: auto">
                <v-data-table
                  item-key="id"
                  v-model="selected_izabrani_tankovi"
                  :headers="headers_modal_izabrani_tankovi"
                  :items="items_modal_izabrani_tankovi"
                  hide-actions
                  class="elevation-1"
                  show-select
                  dense
                  select-all
                  :pagination.sync="pagination"
                >
                  <template slot="headers" slot-scope="props_modal">
                    <tr>
                      <th style="text-align: center; padding: 5px">
                        <v-checkbox
                          primary
                          hide-details
                          @click.native="toggleAll_izabrani_tankovi"
                          :input-value="props_modal.all"
                          :indeterminate="props_modal.indeterminate"
                        ></v-checkbox>
                      </th>
                      <th
                        style="text-align: center; padding: 5px"
                        v-for="header in props_modal.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : '',
                        ]"
                        @click="changeSort(header.value)"
                      >
                        <v-icon>arrow_upward</v-icon>
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props_modal">
                    <tr :active="props_modal.selected">
                      <td style="text-align: center; padding: 5px">
                        <v-checkbox
                          primary
                          hide-details
                          :input-value="props_modal.selected"
                          @click="props_modal.selected = !props_modal.selected"
                        ></v-checkbox>
                      </td>
                      <td
                        style="text-align: center; padding-left: 60px"
                        v-if="
                          props_modal.item.batchPrefix !== null &&
                          props_modal.item.batchPrefix !== ''
                        "
                      >
                        <v-edit-dialog
                          @save="save(props_modal.item)"
                          @cancel="cancel"
                          @open="open(props_modal.item)"
                          @close="close"
                          large
                          cancel-text="Odustani"
                          save-text="OK"
                        >
                          <v-text-field
                            slot="input"
                            label="Edit"
                            v-model="props_modal.item.tankNumberInBatch"
                            v-bind:value="props_modal.item.tankNumberInBatch"
                            single-line
                          ></v-text-field>
                          {{
                            props_modal.item.batchPrefix +
                            " - " +
                            props_modal.item.tankNumberInBatch
                          }}
                        </v-edit-dialog>
                      </td>
                      <td style="text-align: center; padding-left: 60px" v-else>
                        <v-edit-dialog
                          @save="save(props_modal.item)"
                          @cancel="cancel"
                          @open="open(props_modal.item)"
                          @close="close"
                          large
                          cancel-text="Odustani"
                          save-text="OK"
                        >
                          <v-text-field
                            slot="input"
                            label="Edit"
                            v-model="props_modal.item.tankNumberInBatch"
                            v-bind:value="props_modal.item.tankNumberInBatch"
                            single-line
                          ></v-text-field>
                          {{ props_modal.item.tankNumberInBatch }}
                        </v-edit-dialog>
                      </td>
                      <td style="display: none">
                        {{ props_modal.item.tank.id }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.tank.name }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.tank.inventoryNumber }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDate1(props_modal.item.tank.bayingDate) }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{
                          props_modal.item.tank.capacity +
                          " " +
                          props_modal.item.tank.unitOfMeasure.mark
                        }}
                      </td>

                      <td
                        style="text-align: center; padding: 5px"
                        v-if="props_modal.item.tank.materialType !== null"
                      >
                        {{ props_modal.item.tank.materialType }}
                      </td>
                      <td v-else>{{ "" }}</td>
                      <td
                        style="text-align: center; padding: 5px"
                        v-if="props_modal.item.tank.producer !== null"
                      >
                        {{ props_modal.item.tank.producer }}
                      </td>
                      <td v-else>{{ "" }}</td>

                      <td style="text-align: right">
                        <img
                          class="DataTable__Button"
                          title="Pregled korišćenja barika"
                          src="../assets/icons/zatabele/ico-options.svg"
                          alt="delete-item"
                          @click="otvoriDialog(props_modal.item)"
                        />
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs7 pa-2>
                <v-btn
                  slot="activator"
                  class="AppButtonFilled"
                  @click.stop="obrisiPrazneBarike"
                  title="Izbacuju se selektovani barici iz šarže"
                  >Izbaci barike</v-btn
                >
              </v-flex>
              <v-flex xs3 pa-2>
                <v-btn
                  slot="activator"
                  class="AppButtonFilled"
                  @click.stop="otvoriModal"
                  title="Dodaju se selektovani barici u šaržu"
                  >Dodaj barike</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNoteStanjeBarika"
      scrollable
      content-class="ModalInModal"
    >
      <v-container style="padding: 10px">
        <div class="DataTable">
          <v-form ref="form_modal" v-model="valid" lazy-validation>
            <v-layout>
              <v-flex xs11 pa-2 style="font-size: 20px !important">
                {{ this.naslovKoriscenjeBarika }}
              </v-flex>
              <v-flex xs1 pa-2>
                <a
                  class="closeModalInModalBtn"
                  @click.prevent="closeModalInModalStanjeBarika"
                >
                  <v-icon>close</v-icon>
                </a>
              </v-flex>
            </v-layout>

            <v-layout column>
              <v-flex style="overflow: auto">
                <v-data-table
                  :headers="headers_modal_stanje_barika"
                  :items="items_modal_stanje_barika"
                  hide-actions
                  class="elevation-1"
                  :pagination.sync="pagination"
                >
                  <template slot="headers" slot-scope="props_modal">
                    <tr>
                      <th
                        v-for="header in props_modal.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : '',
                        ]"
                        @click="changeSort(header.value)"
                      >
                        <v-icon>arrow_upward</v-icon>
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props_modal">
                    <tr>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.wine }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.phase }}
                      </td>

                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.batchName }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDateTime(props_modal.item.from) }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDateTime(props_modal.item.to) }}
                      </td>

                      <td
                        style="text-align: center; padding: 5px"
                        v-if="props_modal.item.years > 0"
                      >
                        {{
                          props_modal.item.years +
                          " g " +
                          props_modal.item.months +
                          " m"
                        }}
                      </td>
                      <td style="text-align: center; padding: 5px" v-else>
                        {{ "   " + props_modal.item.months + " m" }}
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
    </v-dialog>

    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "TankItem",
  components: {
    TokenComponent,
  },
  data: () => ({
    valid: true,
    ID: "0",
    naziv: undefined,
    opis: undefined,
    kapacitet: undefined,
    jm_select: undefined,
    proizvodjac: undefined,
    datum_kupovine: undefined,
    datum_deaktivacije: undefined,
    menu: "",
    menu1: "",
    label1: "",
    labelKomada: "",
    cena: 0,
    jm_valuta: undefined,
    id_prostorije: 0,
    id_tip_tanka: 0,
    tank_to_items: [],
    jm_items: [],
    room_items: [],
    currency_items: [],
    pozicija: undefined,
    inventoryNumber: "",
    sifarnik: 0,
    // zapremina_burica: 0,
    broj_barika: 1,
    prefiks: "",
    disabled: 1,
    naziv_tip_tanka: "",
    tip_materijala: "",
    nagorelost: undefined,
    enumPom: "",
    dialogNote: false,
    items_modal: [],
    items_modal_izabrani_tankovi: [],
    headers_modal: [
      { text: "Naziv", value: "name" },
      { text: "Inventarni broj", value: "inventoryNumber" },
      { text: "Datum nabavke", value: "bayingDate" },
      { text: "Kapacitet", value: "capacity" },
      // { text: "JM", value: "width" },
      { text: "Materijal", value: "materialType" },
      { text: "Proizvođač", value: "producer" },
      { text: "Funkcije", value: "funkcije", sortable: false },
    ],
    headers_modal_izabrani_tankovi: [
      { text: "Oznaka barika", value: "tankNumberInBatch" },
      { text: "Naziv", value: "tank.name" },
      { text: "Inventarni broj", value: "tank.inventoryNumber" },
      { text: "Datum nabavke", value: "tank.bayingDate" },
      { text: "Kapacitet", value: "tank.capacity" },
      // { text: "JM", value: "width" },
      { text: "Materijal", value: "tank.materialType" },
      { text: "Proizvođač", value: "tank.producer" },
      { text: "Funkcije", value: "funkcije", sortable: false },
    ],
    headers_modal_stanje_barika: [
      { text: "Vino", value: "wine" },
      { text: "Faza", value: "phase" },
      { text: "Šarža", value: "batchName" },
      { text: "Od", value: "from" },
      { text: "Do", value: "to" },
      { text: "Odležavalo", value: "wineType" },
    ],
    singleSelect: false,
    pagination: {
      sortBy: "id",
      rowsPerPage: 10000000,
    },
    selected_izabrani_tankovi: [],
    selected_prazni_barici: [],
    nema_burica: true,
    dialogNote_izabrani_tankovi: false,
    sarza: 0,
    id_tip_tanka_barik: 0,
    dateFormatted: null,
    dateFormatted1: null,
    selected_nova_sarza_barici: [],
    glob_novi_tankovi: [],
    glob_novi_tankovi_pom: [],
    vidljiv_broj_barika: false,
    items_modal_stanje_barika: [],
    dialogNoteStanjeBarika: false,
    naslovKoriscenjeBarika: "Pregled koriscenja barika",
  }),
  watch: {
    datum_kupovine(val) {
      this.dateFormatted = this.formatDate1(this.datum_kupovine);
    },
    datum_deaktivacije(val) {
      this.dateFormatted1 = this.formatDate1(this.datum_deaktivacije);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    isNumber(e) {
      e = e || window.event;
      var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
      var charStr = String.fromCharCode(charCode);

      

      if (!charStr.match(/^[0-9]+$/))
      e.preventDefault();
      return true;
    },
    formatDateTime(date) {
      

      let answer = "";

      if (date !== null && typeof date !== "undefined") {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        // let HH = lokTime.split(":")[0];
        // let mm = lokTime.split(":")[1];

        answer = [day, month, year].join(".");
      }

      return answer;
    },
    closeModalInModalStanjeBarika() {
      this.items_modal_stanje_barika = [];

      this.dialogNoteStanjeBarika = false;
    },
    otvoriDialog(item) {
      //scrollToTop(300);
      let id;
      let name;

      if (typeof item.tank !== "undefined") {
        id = item.tank.id;
        name = item.tank.name;
      } else {
        id = item.id;
        name = item.name;
      }

      this.items_modal_stanje_barika = [];

      this.dialogNoteStanjeBarika = true;
      this.getAllSifarnikStanjeBarika(id);

      this.naslovKoriscenjeBarika = "Pregled korišćenja barika - " + name;
    },

    IzmenaRednogBrojaBarika(id, tankNumberInBatch) {
      let batchTank = {
        id: id,
        tankNumberInBatch: tankNumberInBatch,
      };

      // console.log(JSON.stringify(batchTank));

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/tank_number_in_batch",
          batchTank,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          //  alert("Uspešno su obrisani barici iz šarže.");
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/tank_number_in_batch",
                      batchTank,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // alert("Uspešno su obrisani barici iz šarže.");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    save(e) {
      console.log(e);
      this.IzmenaRednogBrojaBarika(e.id, e.tankNumberInBatch);
    },
    cancel() {},
    open(e) {
      console.log(e);

      

      const index = this.selected_izabrani_tankovi.indexOf(e);
      if (index > -1) {
        this.selected_izabrani_tankovi.splice(index, 1);
      }
    },
    close() {},
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    toggleAll_izabrani_tankovi() {
      if (this.selected_izabrani_tankovi.length)
        this.selected_izabrani_tankovi = [];
      else
        this.selected_izabrani_tankovi =
          this.items_modal_izabrani_tankovi.slice();
    },
    toggleAll_prazni_barici() {
      if (this.selected_prazni_barici.length) this.selected_prazni_barici = [];
      else this.selected_prazni_barici = this.items_modal.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    closeModalInModal() {
      this.selected_prazni_barici = [];
      this.items_modal = [];

      this.dialogNote = false;

      // serverBus.$emit("refresh_tank", this.id_prostorije);
      serverBus.$emit("refresh_tank_pom", this.id_prostorije, this.ID);
    },
    otvoriModal() {
      this.selected_prazni_barici = [];
      this.items_modal = [];

      this.dialogNote = true;
      this.getAllSifarnik();
    },
    closeModalInModal_izabrani_tankovi() {
      this.selected_izabrani_tankovi = [];
      this.items_modal_izabrani_tankovi = [];

      this.dialogNote_izabrani_tankovi = false;

      // serverBus.$emit("refresh_tank", this.id_prostorije);
      serverBus.$emit("refresh_tank_pom", this.id_prostorije, this.ID);
    },
    otvoriModal_izabrani_tankovi() {
      if (this.ID !== 0) {
        this.dialogNote_izabrani_tankovi = true;
        this.getAllSifarnik2();
      } else {
        this.otvoriModal();
      }
    },
    dodajPrazneBarike() {
      if (this.selected_prazni_barici.length === 0)
        alert("Nije izabran ni jedan prazan barik.");
      else {
        let novi_tankovi = [];
        let novi_tankovi_pom = [];

        let objekat;
        let objekat_pom;

        // // console.log(this.selected_prazni_barici);

        this.selected_prazni_barici.forEach(function (entry) {
          objekat = {
            id: entry.id,
          };

          novi_tankovi.push(objekat);

          objekat_pom = {
            id: entry.id,
            capacity: entry.capacity,
            unitOfMeasure: entry.unitOfMeasure,
            name: entry.name,
            bayingDate: entry.bayingDate,
            materialType: entry.materialType,
            producer: entry.producer,
          };

          novi_tankovi_pom.push(objekat_pom);
        });

        // // console.log(novi_tankovi_pom);

        let batchTank = {
          id: this.ID,
        };
        let complexObject = {
          batchTank: batchTank,
          tanks: novi_tankovi,
          batchPrefix: this.prefiks,
        };

        // console.log(JSON.stringify(complexObject));

        this.glob_novi_tankovi = novi_tankovi;
        this.glob_novi_tankovi_pom = novi_tankovi_pom;

        if (this.ID !== 0) {
          this.$http
            .post(
              this.globalServiceLocation +
                this.globalPort +
                "/tank/add_tanks_in_batch",
              complexObject,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              // alert("Uspešno su dodati barici u šaržu.");
              

              this.getAllSifarnik2();

              this.dialogNote = false;
              this.nema_burica = false;

              if (this.dialogNote_izabrani_tankovi === false) {
                this.clear_pom();
                serverBus.$emit("refresh_tank", this.id_prostorije);
              }

            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .post(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/tank/add_tanks_in_batch",
                          complexObject,
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          // alert("Uspešno su dodati barici u šaržu.");
                          this.getAllSifarnik2();

                          this.dialogNote = false;
                          this.nema_burica = false;

                          if (this.dialogNote_izabrani_tankovi === false) {
                            this.clear_pom();
                            serverBus.$emit("refresh_tank", this.id_prostorije);
                          }
                        })
                        .catch((e) => {
                          // // console.log(e.response);

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        } else {
          this.dialogNote = false;
          this.nema_burica = false;

          // alert(this.glob_novi_tankovi.length);

          this.broj_barika = this.glob_novi_tankovi.length;

          this.kapacitet = 0;

          this.glob_novi_tankovi_pom.forEach(
            (element) => (this.kapacitet = this.kapacitet + element.capacity)
          );

          this.jm_select = this.glob_novi_tankovi_pom[0].unitOfMeasure;
        }
      }
    },
    obrisiPrazneBarike() {
      if (this.selected_izabrani_tankovi.length === 0)
        alert("Nije izabran ni jedan barik.");
      else {
        let izabrani_tankovi = [];
        let objekat;

        this.selected_izabrani_tankovi.forEach(function (entry) {
          objekat = {
            id: entry.tank.id,
          };

          izabrani_tankovi.push(objekat);
        });

        let batchTank = {
          id: this.ID,
        };
        let complexObject = {
          batchTank: batchTank,
          tanks: izabrani_tankovi,
          batchPrefix: this.prefiks,
        };

        // console.log(JSON.stringify(complexObject));

        this.$http
          .put(
            this.globalServiceLocation +
              this.globalPort +
              "/tank/remove_tanks_from_batch",
            complexObject,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            //  alert("Uspešno su obrisani barici iz šarže.");

            if (
              this.selected_izabrani_tankovi.length !==
              this.items_modal_izabrani_tankovi.length
            ) {
              this.selected_izabrani_tankovi = [];
              this.getAllSifarnik2();
            } else {
              this.selected_izabrani_tankovi = [];
              this.clear_pom();
              this.closeModalInModal_izabrani_tankovi();
              serverBus.$emit("refresh_tank", this.id_prostorije);
            }
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .put(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank/remove_tanks_from_batch",
                        complexObject,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // alert("Uspešno su obrisani barici iz šarže.");

                        if (
                          this.selected_izabrani_tankovi.length !==
                          this.items_modal_izabrani_tankovi.length
                        ) {
                          this.selected_izabrani_tankovi = [];
                          this.getAllSifarnik2();
                        } else {
                          this.selected_izabrani_tankovi = [];
                          this.clear_pom();
                          this.closeModalInModal_izabrani_tankovi();
                          serverBus.$emit("refresh_tank", this.id_prostorije);
                        }
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);

                        this.selected_izabrani_tankovi = [];
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);

                this.selected_izabrani_tankovi = [];
              }
            }
          });
      }
    },
    getAllSifarnikStanjeBarika(tankId) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/barique_history/" +
            tankId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.items_modal_stanje_barika = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/barique_history/" +
                        tankId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_modal_stanje_barika = response.data;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnik() {
      // // console.log(this.ID);

      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/tank/empty_bariques",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items_modal = response.data;
          // this.getAllSifarnik2();

          let pom_niz = this.glob_novi_tankovi_pom;
          let selected_prazni_barici_pom = [];

          // if(pom_niz.length > 0){
          //   this.items_modal.forEach(function(e){
          //         if (typeof e === "object" ){
          //             pom_niz.forEach(function(element){
          //             if (typeof element === "object" ){

          //                 if (element.id === e.id){
          //                   e["selected"] = true;
          //                   selected_prazni_barici_pom.push(e)
          //                 }
          //             }
          //           });
          //         }
          //       });
          // }

          this.selected_prazni_barici = selected_prazni_barici_pom;

          // console.log(response.data);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/empty_bariques",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_modal = response.data;
                      let pom_niz = this.glob_novi_tankovi_pom;
                      let selected_prazni_barici_pom = [];

                      // if(pom_niz.length > 0){
                      //   this.items_modal.forEach(function(e){
                      //         if (typeof e === "object" ){
                      //             pom_niz.forEach(function(element){
                      //             if (typeof element === "object" ){

                      //                 if (element.id === e.id){
                      //                   e["selected"] = true;
                      //                   selected_prazni_barici_pom.push(e)
                      //                 }
                      //             }
                      //           });
                      //         }
                      //       });
                      // }

                      this.selected_prazni_barici = selected_prazni_barici_pom;

                      // console.log(response.data);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnik2() {
      // // console.log(this.ID);

      if (this.ID != undefined && this.ID != 0) {
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/tank/tanks_in_batch/" +
              this.ID,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // this.selected_izabrani_tankovi = response.data;
            this.items_modal_izabrani_tankovi = response.data;
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank/tanks_in_batch/" +
                          this.ID,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // this.selected_izabrani_tankovi = response.data;
                        this.items_modal_izabrani_tankovi = response.data;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    newSifarnik() {
      var complexObjectRoom;

      if (this.id_prostorije.id == null)
        complexObjectRoom = {
          id: this.id_prostorije,
        };
      else complexObjectRoom = this.id_prostorije;

      var complexObjectTankType;
      let tipTanak;

      if (typeof this.id_tip_tanka.id === "undefined")
        tipTanak = this.id_tip_tanka;
      else tipTanak = this.id_tip_tanka.id;

      complexObjectTankType = {
        id: tipTanak,
      };

      var complexObjectValuta;

      if (typeof this.jm_valuta !== "undefined")
        if (typeof this.jm_valuta.id === "undefined")
          complexObjectValuta = {
            id: this.jm_valuta,
          };
        else
          complexObjectValuta = {
            id: this.jm_valuta.id,
          };
      else complexObjectValuta = null;

      if (tipTanak !== 15)
        var complexObject = {
          name: this.naziv,
          description: this.opis,
          capacity: this.kapacitet,
          unitOfMeasure: this.jm_select,
          producer: this.proizvodjac,
          bayingDate: this.datum_kupovine,
          price: this.cena,
          currency: complexObjectValuta,
          room: complexObjectRoom,
          tankType: complexObjectTankType,
          position: this.pozicija,
          inventoryNumber: this.inventoryNumber,
          deactivationDate: this.datum_deaktivacije,
          materialType: this.tip_materijala,
          toastingLevel: this.nagorelost,
        };
      else if (this.ID !== 0)
        var complexObject = {
          name: this.naziv,
          description: this.opis,
          unitOfMeasure: this.jm_select,
          producer: this.proizvodjac,
          bayingDate: this.datum_kupovine,
          price: this.cena,
          currency: complexObjectValuta,
          room: complexObjectRoom,
          tankType: complexObjectTankType,
          position: this.pozicija,
          inventoryNumber: this.inventoryNumber,
          deactivationDate: this.datum_deaktivacije,
          materialType: this.tip_materijala,
          batchPrefix: this.prefiks,
          toastingLevel: this.nagorelost,
        };
      else {
        let pomComplexObject;

        pomComplexObject = {
          batchTank: {
            name: this.naziv,
            description: this.opis,
            unitOfMeasure: this.jm_select,
            producer: this.proizvodjac,
            bayingDate: this.datum_kupovine,
            price: this.cena,
            currency: complexObjectValuta,
            room: complexObjectRoom,
            tankType: complexObjectTankType,
            position: this.pozicija,
            inventoryNumber: this.inventoryNumber,
            deactivationDate: this.datum_deaktivacije,
            materialType: this.tip_materijala,
            batchPrefix: this.prefiks,
            toastingLevel: this.nagorelost,
          },
          tanks: this.glob_novi_tankovi,
        };

        complexObject = pomComplexObject;
      }

      // console.log(JSON.stringify(complexObject));
      // // // console.log(complexObjectRoom);

      

      let url = "/tank/create";

      if (tipTanak === 15 && this.ID === 0)
        url = "/tank/create/batch_with_tanks";

      this.$http
        .post(
          this.globalServiceLocation + this.globalPort + url,
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.clear_pom();

          serverBus.$emit("refresh_tank", complexObjectRoom.id);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation + this.globalPort + url,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.clear_pom();

                      serverBus.$emit("refresh_tank", complexObjectRoom.id);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
      // }
    },
    newSifarnikZaBarike() {
      var complexObjectRoom;

      if (this.id_prostorije.id == null)
        complexObjectRoom = {
          id: this.id_prostorije,
        };
      else complexObjectRoom = this.id_prostorije;

      var complexObjectTankType;
      let tipTanak;

      if (typeof this.id_tip_tanka.id === "undefined")
        tipTanak = this.id_tip_tanka;
      else tipTanak = this.id_tip_tanka.id;

      complexObjectTankType = {
        id: tipTanak,
      };

      var complexObjectValuta;

      if (typeof this.jm_valuta !== "undefined")
        if (typeof this.jm_valuta.id === "undefined")
          complexObjectValuta = {
            id: this.jm_valuta,
          };
        else
          complexObjectValuta = {
            id: this.jm_valuta.id,
          };
      else complexObjectValuta = null;

      var complexObject;

      if (tipTanak !== 15)
        complexObject = {
          name: this.naziv,
          description: this.opis,
          capacity: this.kapacitet,
          unitOfMeasure: this.jm_select,
          producer: this.proizvodjac,
          bayingDate: this.datum_kupovine,
          price: this.cena,
          currency: complexObjectValuta,
          room: complexObjectRoom,
          tankType: complexObjectTankType,
          position: this.pozicija,
          inventoryNumber: this.inventoryNumber,
          deactivationDate: this.datum_deaktivacije,
          materialType: this.tip_materijala,
          toastingLevel: this.nagorelost,
        };
      else
        complexObject = {
          name: this.naziv,
          description: this.opis,
          unitOfMeasure: this.jm_select,
          producer: this.proizvodjac,
          bayingDate: this.datum_kupovine,
          price: this.cena,
          currency: complexObjectValuta,
          room: complexObjectRoom,
          tankType: complexObjectTankType,
          position: this.pozicija,
          inventoryNumber: this.inventoryNumber,
          deactivationDate: this.datum_deaktivacije,
          materialType: this.tip_materijala,
          toastingLevel: this.nagorelost,
        };

      

      // console.log(JSON.stringify(complexObject));
      // // // console.log(complexObjectRoom);

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/create/multi/" +
            this.broj_barika,
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.clear_pom();

          serverBus.$emit("refresh_tank", complexObjectRoom.id);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/create/multi/" +
                        this.broj_barika,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.clear_pom();

                      serverBus.$emit("refresh_tank", complexObjectRoom.id);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
      // }
    },
    changeSifarnik() {
      

      if(this.datum_deaktivacije !== undefined && this.datum_deaktivacije !== null){
        confirm("Pošto je unet datum deaktivacije šarže svi barici će biti izbačeni iz šarže, a šarža obrisana. Da li želite da nastavite sa izmenom i deaktivacijom šarže?") &&
        this.izvrsiIzmenu();
      }
      else{
        this.izvrsiIzmenu();
      }
      
    },
    izvrsiIzmenu(){
      var complexObjectTankType;
      let tipTanak;

      if (typeof this.id_tip_tanka.id === "undefined")
        tipTanak = this.id_tip_tanka;
      else tipTanak = this.id_tip_tanka.id;

      complexObjectTankType = {
        id: tipTanak,
      };

      var complexObjectRoom;

      if (typeof this.id_prostorije.id === "undefined")
        complexObjectRoom = {
          id: this.id_prostorije,
        };
      else complexObjectRoom = this.id_prostorije;

      var complexObjectValuta;

      if (typeof this.jm_valuta !== "undefined")
        if (typeof this.jm_valuta.id === "undefined")
          complexObjectValuta = {
            id: this.jm_valuta,
          };
        else
          complexObjectValuta = {
            id: this.jm_valuta.id,
          };
      else complexObjectValuta = null;

      var complexObjectUnit;

      if (typeof this.jm_select !== "undefined") {
        if (typeof this.jm_select.id === "undefined")
          complexObjectUnit = {
            id: this.jm_select,
          };
        else
          complexObjectUnit = {
            id: this.jm_select.id,
          };
      }

      if (tipTanak !== 15)
        var complexObject = {
          id: this.ID,
          name: this.naziv,
          description: this.opis,
          capacity: this.kapacitet,
          unitOfMeasure: complexObjectUnit,
          producer: this.proizvodjac,
          bayingDate: this.datum_kupovine,
          price: this.cena,
          currency: complexObjectValuta,
          room: complexObjectRoom,
          tankType: complexObjectTankType,
          position: this.pozicija,
          inventoryNumber: this.inventoryNumber,
          deactivationDate: this.datum_deaktivacije,
          materialType: this.tip_materijala,
          batchPrefix: this.prefiks,
          toastingLevel: this.nagorelost,
        };
      else
        var complexObject = {
          id: this.ID,
          name: this.naziv,
          description: this.opis,
          unitOfMeasure: complexObjectUnit,
          producer: this.proizvodjac,
          bayingDate: this.datum_kupovine,
          price: this.cena,
          currency: complexObjectValuta,
          room: complexObjectRoom,
          tankType: complexObjectTankType,
          position: this.pozicija,
          inventoryNumber: this.inventoryNumber,
          deactivationDate: this.datum_deaktivacije,
          materialType: this.tip_materijala,
          capacity: this.kapacitet,
          piece: this.broj_barika,
          batchTank: true,
          batchPrefix: this.prefiks,
          toastingLevel: this.nagorelost,
        };

      // console.log(JSON.stringify(complexObject));

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/update/" +
            this.ID,
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.clear_pom();

          serverBus.$emit("refresh_tank", complexObjectRoom.id);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/update/" +
                        this.ID,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.clear_pom();

                      serverBus.$emit("refresh_tank", complexObjectRoom.id);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllJediniceMere() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure/group/1",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let niz = [];

          response.data.forEach(function (entry) {
            if (entry.mark !== "ml") niz.push(entry);
          });

          this.jm_items = niz;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/group/1",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let niz = [];

                      response.data.forEach(function (entry) {
                        if (entry.mark !== "ml") niz.push(entry);
                      });

                      this.jm_items = niz;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllProstorije() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/room/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // console.log(response.data);

          this.room_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/room/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.room_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllTankTipovi() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/tank_type/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // console.log(response.data);

          this.tank_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_type/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.tank_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllValute() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/currency/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // console.log(response.data);

          this.currency_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/currency/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.currency_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.ID != "" && this.ID != "0") {
          this.changeSifarnik();
        } else {
          if (this.id_tip_tanka_barik === 14 && this.ID === 0)
            if (this.broj_barika > 0) {
              this.newSifarnikZaBarike();
            } else alert("Niste izabrali koliki broj barika unosite.");
          else {
            this.newSifarnik();
          }
        }
      }
    },
    clear_pom(){
      this.clear();
      this.postaviLitar();
    },
    clear() {
      

      if(this.$refs.form !== undefined)
        this.$refs.form.reset();
        
      this.ID = 0;

      this.id_tip_tanka = 0;
      this.sarza = 0;

      this.labelKomada = "Komada";
      this.label1 = "Datum kupovine";
      this.vidljiv_broj_barika = false;

      this.id_tip_tanka_barik = 0;

      this.broj_barika = 1;
      this.glob_novi_tankovi = [];
      this.glob_novi_tankovi_pom = [];

      this.nagorelost = undefined;
      this.enumPom = undefined;
    },
    postaviLitar(){
      let _this = this;

      setTimeout(() => {
        let litar;

        _this.jm_items.forEach(function (entry) {
          if (entry.mark === "l") litar = entry;
        });

        _this.jm_select = litar;
      }, 200);
    },
    changeRoute(a) {
      // // console.log(a);

      

      if (typeof a !== "undefined") {
        // // console.log(a.id);

        if (typeof a.id !== "undefined") {
          // this.id_tip_tanka = a.id;

          this.id_tip_tanka_barik = a.id;

          if (a.enumLable !== null) this.enumPom = a.enumLable;
          else this.enumPom = undefined;

          if (a.id === 15) {
            this.sarza = 1;
            this.kapacitet = undefined;
            // this.jm_select = undefined;
            this.label1 = "Datum formiranja";
            this.labelKomada = "Barika";

            this.id_tip_tanka = a.id;

            this.vidljiv_broj_barika = true;

            if (this.ID === 0) {
              this.broj_barika = undefined;
              this.nema_burica = true;
            }
          } else {
            this.label1 = "Datum kupovine";
            this.labelKomada = "Komada";
            this.sarza = 0;

            this.vidljiv_broj_barika = false;
          }

          this.naziv_tip_tanka = a.name;

          if (a.name === "barik") {
            this.jm_select = {
              id: 2,
              mark: "l",
              name: "Litar",
            };

            this.disabled = 0;
          } else {
            // this.jm_select = undefined;
            this.disabled = 1;
          }
        } else if (this.naziv_tip_tanka === "barik") {
          this.jm_select = {
            id: 2,
            mark: "l",
            name: "Litar",
          };
          this.disabled = 0;

          let pomIndex = this.tank_to_items.findIndex(
            (element) => element.id === a
          );

          this.enumPom = undefined;

          if (pomIndex >= 0)
            if (this.tank_to_items[pomIndex].enumLable !== null)
              this.enumPom = this.tank_to_items[pomIndex].enumLable;
        } else {
          // this.jm_select = undefined;
          this.disabled = 1;

          let pomIndex = this.tank_to_items.findIndex(
            (element) => element.id === a
          );

          this.enumPom = undefined;

          if (pomIndex >= 0)
            if (this.tank_to_items[pomIndex].enumLable !== null)
              this.enumPom = this.tank_to_items[pomIndex].enumLable;
        }
      }
    },
  },
  mounted() {
    this.clear_pom();

    this.getAllTankTipovi();
    this.getAllJediniceMere();
    this.getAllProstorije();
    this.getAllValute();

    

    serverBus.$on("otvori_modal", (item) => {
      this.ID = item.id;
      this.naziv = item.name;
      this.opis = item.description;

      this.kapacitet = item.capacity;

      if (item.unitOfMeasure !== null) this.jm_select = item.unitOfMeasure.id;

      this.proizvodjac = item.producer;

      this.datum_kupovine = item.bayingDate;
      this.dateFormatted = this.formatDate1(item.bayingDate);

      this.datum_deaktivacije = item.deactivationDate;
      this.dateFormatted1 = this.formatDate1(item.deactivationDate);

      this.cena = item.price;
      this.tip_materijala = item.materialType;

      if (
        item.tankType.enumLable === "barique" ||
        item.tankType.enumLable === "barrel"
      )
        this.nagorelost = item.toastingLevel;
      else this.nagorelost = undefined;

      if (item.currency !== null) this.jm_valuta = item.currency.id;

      this.id_prostorije = item.room.id;
      this.id_tip_tanka = item.tankType.id;

      // if (this.id_tip_tanka === 15)
      //   this.sarza = 1;
      // else
      //   this.sarza = 0;

      if (this.id_tip_tanka === 15) {
        this.sarza = 1;
        this.label1 = "Datum formiranja";
        this.labelKomada = "Barika";

        this.vidljiv_broj_barika = true;

        if (this.ID === 0) this.broj_barika = undefined;
      } else {
        this.label1 = "Datum kupovine";
        this.labelKomada = "Komada";
        this.sarza = 0;

        this.vidljiv_broj_barika = false;
      }

      this.naziv_tip_tanka = item.tankType.name;

      this.pozicija = item.position;
      this.inventoryNumber = item.inventoryNumber;

      this.broj_barika = item.piece;
      this.prefiks = item.batchPrefix;

      if (item.piece === null || item.piece === 0) {
        this.otvoriModal();
        // this.getAllSifarnik();
        this.nema_burica = true;
      } else {
        this.otvoriModal_izabrani_tankovi();

        this.nema_burica = false;

        // this.getAllSifarnik2();
      }
    });

    serverBus.$on("applied_tank", (item) => {
      // alert(item.name);
      // alert(item.position);
      

      // console.log(item);

      if (typeof item !== "undefined") {
        this.ID = item.id;
        this.naziv = item.name;
        this.opis = item.description;

        this.kapacitet = item.capacity;

        if (item.unitOfMeasure !== null) {
          var indeks = this.jm_items.findIndex(
            (x) => x.id === item.unitOfMeasure.id
          );

          this.jm_select = this.jm_items[indeks];
        }

        this.proizvodjac = item.producer;
        this.datum_kupovine = item.bayingDate;
        this.dateFormatted = this.formatDate1(item.bayingDate);

        this.datum_deaktivacije = item.deactivationDate;
        this.dateFormatted1 = this.formatDate1(item.deactivationDate);

        this.cena = item.price;
        this.tip_materijala = item.materialType;

        if (
          item.tankType.enumLable === "barique" ||
          item.tankType.enumLable === "barrel"
        )
          this.nagorelost = item.toastingLevel;
        else this.nagorelost = undefined;

        if (item.currency !== null) this.jm_valuta = item.currency.id;

        this.id_prostorije = item.room.id;
        this.id_tip_tanka = item.tankType.id;

        // if (this.id_tip_tanka === 15)
        //   this.sarza = 1;
        // else
        //   this.sarza = 0;

        if (this.id_tip_tanka === 15) {
          this.sarza = 1;
          this.label1 = "Datum formiranja";
          this.labelKomada = "Barika";

          this.vidljiv_broj_barika = true;

          if (this.ID === 0) this.broj_barika = undefined;
        } else {
          this.label1 = "Datum kupovine";
          this.labelKomada = "Komada";
          this.sarza = 0;

          this.vidljiv_broj_barika = false;
        }

        this.naziv_tip_tanka = item.tankType.name;

        this.pozicija = item.position;
        this.inventoryNumber = item.inventoryNumber;

        this.broj_barika = item.piece;
        this.prefiks = item.batchPrefix;

        if (item.piece === null || item.piece === 0) this.nema_burica = true;
        else this.nema_burica = false;
      }
    });

    serverBus.$on("tank_item", (idRoom) => {
      

      this.clear_pom();

      this.id_prostorije = idRoom;
      this.id_tip_tanka_barik = 0;
    });


    // serverBus.$off("applied_tank");
    // serverBus.$off("refresh_tank");
    // serverBus.$off("refresh_tank_pom");
    // serverBus.$off("otvori_modal");
  },
};
</script>

<style lang="scss" scoped>
.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}
.tankItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 30px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
</style>
